import React from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputSwitch } from 'primereact/inputswitch';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

/* „Ko je najbliži ovom utovaru" — jedino pitanje zbog kog ovaj prozor postoji.

   Udaljenost je DRUMSKA i merena u smeru vozilo -> mesto, jer to je vožnja
   koju neko treba da odradi. Kad rutiranje zakaže, prikazuje se vazdušna
   linija ali IZRIČITO označena: 58 km vazduhom preko Dunava i 58 km putem
   nisu isti podatak, a dispečer po njima raspoređuje ljude.

   Boja u prvoj koloni nije ukras — ista je kao boja rute tog vozila kad se
   uključi prikaz na karti, pa se red u tabeli i linija na mapi spajaju
   pogledom, bez čitanja registracije. */

/* Paleta je fiksna i redom se troši. Nasumična boja po registraciji bi na
   svakom osvežavanju dala drugu boju istom vozilu. */
export const BOJE_RUTA = ['#1565c0', '#8e24aa', '#d81b60', '#2e7d32', '#ef6c00', '#00838f', '#5d4037', '#455a64'];

/* 3438 s -> „57min 18 sec". Sati se pišu samo kad ih ima — „0h 57min" je duže
   a ne kaže više. */
const trajanje = (s) => {
    if (s == null) return '—';
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sek = Math.round(s % 60);
    if (h) return `${h}h ${m}min`;
    return m ? `${m}min ${sek} sec` : `${sek} sec`;
};

const DialogVozilaUBlizini = ({
    vidljiv, lokacija, vozila, ucitava, vazdusna,
    prikaziRute, onPrikaziRute, onOsvezi, onVozilo, onZatvori,
}) => {
    const { t } = useTranslation();

    const kolonaBoje = (r, opcije) => (
        <span className="gps-bl-red">
            <span className="gps-bl-boja" style={{ background: BOJE_RUTA[opcije.rowIndex % BOJE_RUTA.length] }} />
            {/* Klik na registraciju vodi na vozilo — prozor je spisak kandidata,
                a sledeći korak je uvek „hajde da vidim gde je tačno". */}
            <button type="button" className="gps-bl-veza" onClick={() => onVozilo(r)}>
                {r.registracija}
                {!!r.vozac && <small>{r.vozac}</small>}
            </button>
        </span>
    );

    const kolonaKm = (r) => (
        <span className={r.vazdusna ? 'gps-bl-vazdusna' : undefined}
              title={r.vazdusna ? t('gps.blizinaVazdusnaOpis') : undefined}>
            {r.km == null ? '—' : r.km.toLocaleString('sr-RS', { maximumFractionDigits: 1 })}
            {r.vazdusna && <i className="pi pi-info-circle" />}
        </span>
    );

    return (
        <Dialog
            header={t('gps.blizinaNaslov')}
            visible={vidljiv}
            onHide={onZatvori}
            className="gps-dijalog-blizina"
            style={{ width: '48rem', maxWidth: '96vw' }}
            draggable={false}
            dismissableMask
        >
            <div className="gps-bl-lokacija">
                <span className="gps-bl-oznaka">{t('gps.blizinaLokacija')}:</span>
                <span className="gps-bl-adresa">{lokacija?.naziv}</span>
            </div>

            <div className="gps-bl-alatke">
                <label className="gps-bl-prekidac" htmlFor="gps-bl-rute">
                    <span>{t('gps.blizinaPrikazRuta')}</span>
                    <InputSwitch
                        inputId="gps-bl-rute"
                        checked={prikaziRute}
                        onChange={(e) => onPrikaziRute(e.value)}
                    />
                    <span className="gps-bl-stanje">
                        {prikaziRute ? t('gps.blizinaUkljucen') : t('gps.blizinaIskljucen')}
                    </span>
                </label>

                <Button
                    type="button"
                    icon="pi pi-refresh"
                    label={t('gps.osvezi')}
                    className="p-button-text p-button-sm"
                    loading={ucitava}
                    onClick={onOsvezi}
                />
            </div>

            {/* Poruka stoji iznad tabele, a ne u koloni: kad rutiranje otkaže,
                otkaže za ceo spisak, pa upozorenje pripada spisku. */}
            {vazdusna && !ucitava && !!(vozila || []).length && (
                <div className="gps-bl-upozorenje">
                    <i className="pi pi-exclamation-triangle" />
                    {t('gps.blizinaVazdusnaSve')}
                </div>
            )}

            <DataTable
                value={vozila || []}
                loading={ucitava}
                sortField="km"
                sortOrder={1}
                scrollable
                scrollHeight="42vh"
                className="turePregledTable gps-bl-tabela stavke-tabela"
                emptyMessage={t('gps.blizinaNema')}
            >
                <Column header={t('gps.vozilo')} body={kolonaBoje} style={{ minWidth: '170px' }} />
                <Column field="sektor" header={t('gps.sektor')} style={{ minWidth: '150px' }}
                        body={(r) => r.sektor || '—'} />
                <Column field="km" header={t('gps.blizinaUdaljenost')} sortable
                        style={{ minWidth: '120px' }} body={kolonaKm} />
                <Column field="sekundi" header={t('gps.blizinaVreme')} sortable
                        style={{ minWidth: '140px' }} body={(r) => trajanje(r.sekundi)} />
            </DataTable>
        </Dialog>
    );
};

export default DialogVozilaUBlizini;
